import styled from '@emotion/styled';
import { mediaMax, spacing } from 'presentations/views/styles';
import { blueGrayPale, gray04, white } from 'presentations/views/styles/color';
import { ReactNode } from 'react';
import Transition from 'presentations/views/components/atoms/Transition';

interface Props {
  header: ReactNode;
  content: ReactNode;
  footer?: ReactNode;
}
export default function Component(props: Props) {
  return (
    <Transition name="fade" in>
      <ChatContainer>
        <HeaderWrapper>{props.header}</HeaderWrapper>
        <MainWrapper>{props.content}</MainWrapper>
        {props.footer && <FooterWrapper>{props.footer}</FooterWrapper>}
      </ChatContainer>
    </Transition>
  );
}
const ChatContainer = styled.div`
  height: 100%;
  ${mediaMax.tablet} {
    width: 100vw;
    height: fit-content;
  }
`;
const HeaderWrapper = styled.div`
  background-color: ${white};
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;
const MainWrapper = styled.div`
  width: 100%;
  height: inherit;
`;
const FooterWrapper = styled.div`
  background-color: ${white};
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  ${mediaMax.tablet} {
    position: fixed;
    height: 56px;
  }
`;
